<template>
    <v-layout row>
        <v-flex xs12>
            <v-card class="elavation-1 transparent">
                <v-toolbar class="transparent" flat height="37">
                    <v-btn-toggle v-model="toggle_view" >
                        <v-btn small title="View all">
                            All
                        </v-btn> 
                        <v-btn small title="View unread only">
                            Unread ({{unreadCount}})
                        </v-btn>
                    </v-btn-toggle>  
                    <v-spacer></v-spacer>
                    <v-btn dark icon @click="markAllRead" title="Mark all as Read" :loading="loading_read" :disabled="hasReadAll">
                        <v-icon>mark_email_read</v-icon>
                    </v-btn>
                    <v-btn dark icon @click="markAllUnRead" title="Mark all as Unread" :loading="loading_unread" :disabled="hasUnreadAll">
                        <v-icon>mark_as_unread</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-progress-linear indeterminate v-if="loading" height="3" style="margin-top:0px;"></v-progress-linear>
            </v-card>
            <v-card class="mt-5">
                <v-data-table
                    :headers="headers"
                    :items="notifications_filtered"
                    :loading="loading"
                    hide-headers
                    hide-actions
                >
                    <template v-slot:items="props">
                        <tr>
                            <td>
                                <div :class="props.item.itemClicked?'elavation-1':'elavation-1 primary lighten-4 black--text' " @click="viewDetails(props.item)" title="Click to view details" style="margin:0px -22px 0px -22px; cursor:pointer; overflow:hidden">
                                    <v-layout row>
                                        <v-flex grow pa-1>
                                            <v-chip>
                                                <v-avatar>
                                                    <v-img ref="avatar" :src="awsS3Helper.getAvatarUrl(props.item.createdBy.userId)"></v-img>
                                                </v-avatar>
                                                <b>{{props.item.createdBy.firstName}} {{props.item.createdBy.lastName}}</b>
                                            </v-chip>
                                            <span style="margin-left:5px;">{{dateFormat.formatDate(props.item.createdOn)}}</span>                  
                                        </v-flex>
                                    </v-layout>
                                    <v-layout row>
                                        <v-flex grow pa-1>
                                            <div class="text-xs-left" style="margin:10px;">
                                                {{props.item.message}}
                                            </div>
                                            <div v-if="props.item.comment" class="font-italic" style="margin-left:10px;">
                                                {{props.item.comment}}
                                            </div>
                                        </v-flex>
                                    </v-layout>
                                </div>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-card>
            <v-btn v-show="remainingRecords>0" block title="Load Previous" @click="getNotifications(false)" :loading="loading">
                <v-icon>fas fa-angle-down</v-icon>
            </v-btn>
        </v-flex>
    </v-layout>  
</template>
<script>

import dateFormat from '@/common/date_format'
import notificationsApi from '@/api/notifications'
import awsS3Helper from '@/helpers/aws-s3'
import Vue from 'vue'

const signalR = require('@microsoft/signalr'); 
Vue.prototype.$signalR = signalR;

export default {  
    name: 'Notifications',
    metaInfo: {
        title: 'Notifications',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: 'View my notifications and announcemnts' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
            ]
    },
    components: {},      
    data () {
        return {
            error: false,
            errorMessage: null,
            loading: false,
            loading_read: false,
            loading_unread: false,
            signalRConnection: null, 
            headers: [
                {text: 'Message',align: 'left',value: '', width: '100%', sortable:false}
             ],
            notifications: [],
            remainingRecords: 0,
            lastNotificationId: "0",
            toggle_view: 0
        }
    },
    methods: {
        async markAllUnRead() {
            try {
                this.loading_unread = true
                await notificationsApi.markAllUnRead()
                await this.getNotifications(true)
                this.loading_unread = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        async markAllRead() {
            try {
                this.loading_read = true
                await notificationsApi.markAllRead()
                await this.getNotifications(true)
                this.loading_read = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        async viewDetails(item) {
            try {
                var data = {
                    notificationId: item.notificationId
                }
                notificationsApi.clicked(data)
                this.$router.push(item.itemLink)
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        async initializeSignalR() {
            await this.signalRConnection.start().catch(err => console.error(err));
            await this.signalRConnection.invoke(process.env.VUE_APP_HUB_NOTIFICATIONS_INVOKE, this.pageQueryId);
            
            this.signalRConnection.on(process.env.VUE_APP_HUB_NOTIFICATIONS_PUSHDATA, data => {
                this.notifications.unshift(data)
            });
        },
        async getNotifications(pageLoad) {
            try {
                this.loading = true
                const response = await notificationsApi.get(this.lastNotificationId)
                if (response.status == 200) {
                    if (pageLoad) {
                        this.notifications = response.data.items
                    } else {
                        response.data.items.forEach(item => {
                            this.notifications.push(item)
                        })
                    }
                    
                    this.remainingRecords = response.data.remainingRecords

                    if (this.notifications.length>0) 
                        this.lastNotificationId = this.notifications[this.notifications.length-1].notificationId
                }

                this.$store.commit('setNotificationsData', this.notifications)

                this.loading = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        }
    },
    created() {
        this.awsS3Helper = awsS3Helper
        this.dateFormat = dateFormat
        if (this.$store.state.notifications)
            this.notifications = this.$store.state.notifications

        // update header titles
        this.$root.$emit('setHeaderTitles', {
            display: true,
            headerTitle: '',
            headerPageTitle: 'Notifications'
        })

        this.getNotifications(true)

        //signalR
        this.signalRConnection = new this.$signalR.HubConnectionBuilder()
                          .withUrl(`${process.env.VUE_APP_HUB_URL}notifications`) 
                          .configureLogging(this.$signalR.LogLevel.Information) //this.$signalR.LogLevel.Error
                          .withAutomaticReconnect()
                          .build();
    },
    async mounted() { 
        await this.initializeSignalR()
    },
    computed: {
        pageQueryId() {
            return `Notifications_${this.$store.state.userId}`
        },
        readCount() {
            return this.notifications.filter(x => {
                return x.itemClicked
            }).length
        },
        unreadCount() {
            return this.notifications.filter(x => {
                return !x.itemClicked
            }).length
        },
        hasUnreadAll() {
            return this.unreadCount == this.notifications.length
        },
        hasReadAll() {
            return this.readCount == this.notifications.length
        },
        notifications_filtered() {
            if (this.toggle_view==0) return this.notifications
            else return this.notifications.filter(x=> !x.itemClicked)
        }
    },
}
</script>